import { fetch } from "../utils/scsFetch";
import { URL_SURVEY_API,URL_SUBTIER_API } from '../utils/constEnvVariables'


export const saveSurveyResponse = function (request, accessToken) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        body: JSON.stringify(request)
    }

    return fetch(`${URL_SURVEY_API}/surveys/answer`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export const updateSurveyResponse = function (surveyId, supplierNumber, response, accessToken) {
    const requestOptions = {
        method: 'PATCH',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(response)
    }

    return fetch(`${URL_SURVEY_API}/surveys/answer/${surveyId}&${supplierNumber}`, requestOptions)
        .then(response => {
            return response;
        })
        .catch(error => { throw error });
}


export const getSurveyResponse = function (campaignAssigned, userInfo, accessToken, isAuthMethodOkta) {
    let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/COC" : "surveys";
    let requestOptions = { method: "GET", headers: { Authorization: `Bearer ${accessToken}` } };

    return fetch(`${URL_SURVEY_API}/${pathParam}/answer/${campaignAssigned.id}&${campaignAssigned.assignments[0].supplierNumber}`, requestOptions)
        .then(res => { return res })
        .catch(error => {
            console.log(error);
            //There is not answers in db yet
            return [];
        })
}

export const getDetailSurveyResponse = function (campaignId, supplierNumber, accessToken) {
    return fetch(`${URL_SURVEY_API}/surveys/answer/${campaignId}&${supplierNumber}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }).then(res => { return res })
        .catch(error => {
            console.log(error);
            return [];
        })
}

export const getSurveyById = function (surveyId, accessToken) {
    let requestOptions = { method: "GET", headers: { Authorization: `Bearer ${accessToken}` } };

    return fetch(`${URL_SURVEY_API}/surveys/survey/${surveyId}`, requestOptions)
        .then(res => { return res })
        .catch(error => {
            console.log(error);
            return null;
        })
}

export const saveUserResponse = function (request, accessToken, isAuthMethodOkta) {
    let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/COC" : "surveys";
    let requestOptions = { method: "POST", headers: { Authorization: `Bearer ${accessToken}` }, body: JSON.stringify(request) };

    return fetch(`${URL_SURVEY_API}/${pathParam}/generic/response`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export const getFileS3 = async function (campaignId, file, accessToken) {
    return await fetch(`${URL_SURVEY_API}/surveys/files/${campaignId}&${file}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }).then(res => { return res })
        .catch(error => {
            console.log(error);
            //There is not answers in db yet
            return "";
        })
}

export const getAllCountryList = function (accessToken) {
    return fetch(`${URL_SURVEY_API}/surveys/generic/countries?localeCode=en_US`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }).then(res => {
        return res !== undefined ? Object.values(res).sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1) : [];
    }
    )
        .catch(error => {
            console.log(error);
            return [];
        })
}

export const getAgreementByCountry = function (isoCode, accessToken) {
    return fetch(`${URL_SURVEY_API}/surveys/tps/agreement/${isoCode}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    }).then(res => {
        return res !== undefined ? Object.values(res).sort((a, b) => a.agreementname.toLowerCase() > b.agreementname.toLowerCase() ? 1 : -1) : [];
    }
    )
        .catch(error => {
            console.log(error);
            return [];
        })
}

export const saveNewAddedSubTierSuppliers = function (request, accessToken, isAuthMethodOkta) {
    let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/COC" : "surveys";
    let requestOption = { method: "POST", headers: { Authorization: `Bearer ${accessToken}` }, body: JSON.stringify(request) };
    return fetch(`${URL_SURVEY_API}/${pathParam}/subtier`, requestOption)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        throw error;
      });
  };

export const getSubtierSupplierData = function (supplierNumber, accessToken, isAuthMethodOkta) {
    let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/COC" : "surveys";
    let requestOption = { method: "GET", headers: { Authorization: `Bearer ${accessToken}` } };
    return fetch(`${URL_SURVEY_API}/${pathParam}/subtier/${supplierNumber}`, requestOption)
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw error;
      });
};

export const deleteSubtierSupplierData = (req, accessToken, isAuthMethodOkta) => {
    let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/COC" : "surveys";
    let requestOption = { method: "DELETE", headers: { Authorization: `Bearer ${accessToken}` } };
    return fetch(`${URL_SURVEY_API}/${pathParam}/subtier/${req.primarySupplierNo}/${req.id}`, requestOption)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      });
};

export const saveTpsAnswers = function (request, accessToken, surveyCode) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(request)
    }

    return fetch(`${URL_SURVEY_API}/surveys/${surveyCode.toLowerCase()}/answer`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export const signInSurveyLogin = function (urlEncryptData) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify({
            urlEncryptData: urlEncryptData, 
        })
    }
     return fetch(`${URL_SURVEY_API}/surveys-ext/subtier/encryptedLogin`, requestOptions)
        .then(response => {
            return response
        })
        .catch(error => { throw error });
}

export const getSubtierCatalogue = function (surveyCode, accessToken, isAuthMethodOkta) {
    let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/COC" : "surveys";
    let requestOption = { method: "GET", headers: { Authorization: `Bearer ${accessToken}` } };
    return fetch(`${URL_SURVEY_API}/${pathParam}/subtier/catalog/${surveyCode}`, requestOption)
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw error;
      });
  };

  export const updateCampaignStatus = function (req, accessToken, isAuthMethodOkta) {
    let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/COC" : "surveys";
    let requestOption = { method: "PATCH", headers: { Authorization: `Bearer ${accessToken}` }, body: JSON.stringify(req) };
    return fetch(`${URL_SURVEY_API}/${pathParam}/subtier/status`, requestOption)
      .then((res) => {
        return res;
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  };

  export const deleteOSContact = (id, accessToken) => {
    let requestOption = { method: "DELETE", headers: { Authorization: `Bearer ${accessToken}` } };
    return fetch(`${URL_SURVEY_API}/surveys/generic/remove/oscontact/${id}`, requestOption)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      });
  }

  export const getSubtierCleansingData = async (campaignId, accessToken) => {
    return fetch(`${URL_SURVEY_API}/surveys/subtier/cleansing/${campaignId}`,{
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
        }).then((res) => {
            return res;
        })
        .catch((error) => {
            console.log(error);
            throw error;
        });
  }

    export const deleteSubtierRegistry = function (subtierIdList,accessToken) {
        const requestOptions = {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            },
            body: JSON.stringify(subtierIdList)
        }

        return fetch(`${URL_SURVEY_API}/surveys/subtier/cleansing/delete`, requestOptions)
            .then(response => {
                return response;
            })
            .catch(error => { throw error });
    }

    export const getSubtierMasterData = async (accessToken) => {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            }
        }

        return fetch(`${URL_SUBTIER_API}/cleansing/golden-records`, requestOptions)
            .then(response => {
                return response;
            })
            .catch(error => { throw error });
    }

    export const getSubtierMasterDataByName = async (inputValue,accessToken) => {
        return fetch(`${URL_SUBTIER_API}/cleansing/golden-records?subtierName=${inputValue}`,{
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            }
            }).then((res) => {
                return res;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    }

    export const saveSubtierMasterData = async (accessToken,goldenRecord) => {
        return fetch(`${URL_SURVEY_API}/surveys/subtier/cleansing`,{
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            },
            body: JSON.stringify(goldenRecord)
            }).then((res) => {
                return res;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    }

    export const deleteSubtierMaster = async function (subtierSupplierNo,accessToken) {
        return fetch(`${URL_SURVEY_API}/surveys/subtier/deletesubtiermaster/${subtierSupplierNo}`,{
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            }
            }).then((res) => {
                return res;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    }

    export const updateSubtierMasterData = async (accessToken,goldenRecord) => {
        return fetch(`${URL_SURVEY_API}/surveys/subtier/updatesubtiermaster`,{
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            },
            body: JSON.stringify(goldenRecord)
            }).then((res) => {
                return res;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    }

    export const linkSubtierMaster = async function (request, accessToken) {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            },
            body: JSON.stringify(request)
        }
    
        return fetch(`${URL_SURVEY_API}/surveys/subtier/linksubtiermaster`, requestOptions)
            .then(response => {
                return response
            })
            .catch(error => { throw error });
    }

    export const getTemplateBySurveyCode = (surveyCode, accessToken) => {
        return fetch(`${URL_SURVEY_API}/surveys/notification/template/${surveyCode}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
          .then((res) => {
            return res;
          })
          .catch((error) => {
            console.log(error);
            throw error;
          });
      };

    export const getSelfServiceTemplateBySurveyCode = (surveyCode, accessToken) => {
        return fetch(`${URL_SURVEY_API}/surveys/notification/template/selfservice/${surveyCode}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
          .then((res) => {
            return res;
          })
          .catch((error) => {
            console.log(error);
            throw error;
          });
      };

      export const getSurveyHistoryBySurveyCode = (request, accessToken) => {
        return fetch(`${URL_SURVEY_API}/surveys/generic/surveyhistory`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(request)
        })
          .then((res) => {
            return res;
          })
          .catch((error) => {
            console.log(error);
            throw error;
          });
      };
    export const getSurveyLiterals = async (surveyId, locale, accessToken, isAuthMethodOkta) => {
        let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys";
        let requestOptions = { method: "GET", headers: { Authorization: `Bearer ${accessToken}` } };
        let path = locale ? `${URL_SURVEY_API}/${pathParam}/literals/${surveyId}?locale=${locale}` : `${URL_SURVEY_API}/${pathParam}/literals/${surveyId}`;
        return fetch(path, requestOptions)
            .then((res) => {
                return res;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            }
        );
    }
    /*CR2-75
     * Author: RAZ9N14:
     * Methof to  post subtier data */
    export const saveSubtierRecords = async (accessToken,goldenRecord) => {
        return fetch(`${URL_SUBTIER_API}/cleansing/golden-records`,{
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            },
            body: JSON.stringify(goldenRecord)
            }).then((res) => {
                return res;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    }

    export const createSubtierSupplierRelation = async (subtierSupplierData, accessToken) => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            },
            body: JSON.stringify(subtierSupplierData)
        }

        return fetch(`${URL_SUBTIER_API}/cleansing/link-records`, requestOptions).then((res) => {
            return res;
        })
        .catch((error) => {
            console.log(error);
            throw error;
        });;
    }

    export const getSurveyTemplates = async (accessToken) => {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            },
        }
        return fetch(`${URL_SURVEY_API}/surveys/templates`, requestOptions).then((res) => {
            return res;
        })
        .catch((error) => {
            console.log(error);
            throw error;
        });;
    }

    export const saveSurveySelfService = async (payloadData, accessToken) => {
        const requestOptions = {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(payloadData),
        };
        return fetch(`${URL_SURVEY_API}/surveys`, requestOptions)
          .then((res) => {
            return res;
          })
          .catch((error) => {
            console.log(error);
            throw error;
          });
    };

    export const deleteSurveySelfService = async (surveyId, accessToken) => {
        const requestOptions = {
          method: "DELETE",
          headers: {
            'Authorization': `Bearer ${accessToken}`,
          }
        };
        return fetch(`${URL_SURVEY_API}/surveys/${surveyId}`, requestOptions)
          .then((res) => {
            return res;
          })
          .catch((error) => {
            console.log(error);
            throw error;
          });
    };

    export const getAvailableLanguages = async (accessToken) => {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            },
        }
        return fetch(`${URL_SURVEY_API}/surveys/languageList`, requestOptions).then((res) => {
            return res;
        })
        .catch((error) => {
            console.log(error);
            throw error;
        });;
    }

    export const getAvailableSurveyCodes = async (accessToken) => {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
            },
        }
        return fetch(`${URL_SURVEY_API}/surveys/surveyCodes`, requestOptions).then((res) => {
            return res;
        })
        .catch((error) => {
            console.log(error);
            throw error;
        });;
    }


